import { Node } from '@tiptap/pm/model';

export enum SchemaVersion {
  V1 = '1',
}

export type ServerValidatorFunction<T> = (
  node: Node,
  attrs: T,
  filtered: Record<string, any>
) => boolean;
